<template>
    <div class="login">
        <img src="../assets/login.png" style="height: 180px; margin: 24px;">
        <h1 class="title">Log in to continue</h1>
        <fb-signin-button
                v-if="isLoading === false"
                :params="fbSignInParams"
                @success="onSignInSuccess"
                @error="onSignInError">
            <b-button type="is-facebook" size="is-medium">
                <span class="has-text-white">
                    <md-icon style="color: #ffffff">link</md-icon> Sign in With Facebook
                </span>
            </b-button>
        </fb-signin-button>
        <md-progress-spinner v-if="isLoading === true" md-mode="indeterminate"></md-progress-spinner>
    </div>
</template>

<script>
    import BButton from "buefy/src/components/button/Button";
    import bus from '../bus';

    export default {
        name: "Login",
        components: {BButton},
        data () {
            return {
                fbSignInParams: {
                    scope: 'email',
                    return_scopes: true
                },
                isLoading: false
            }
        },
        methods: {
            onSignInSuccess (res) {
                const vm = this;
                vm.isLoading = true;
                let tokenUrl =`${vm.$domain}/auth/facebook/token?access_token=${res.authResponse.accessToken}`;
                vm.axios.get(tokenUrl, res)
                    .then(function (loginRes) {
                        let creds = loginRes.data;
                        localStorage.token = creds.access_token;
                        localStorage.user = creds.userId;
                        const now = new Date();
                        localStorage.expiry = now.getTime() + 1209600000;
                        bus.$emit('loginStatus', true);
                        let url = `${vm.$host}/users/${localStorage.user}?access_token=${localStorage.token}`;
                        vm.axios.get(url)
                            .then(function (res) {
                                let to = vm.$route.query.to;
                                if(res.data.tel) {
                                    if(res.data.verified) {
                                        localStorage.verified = true;
                                        if (to) {
                                            vm.$router.push({name: to})
                                        } else {
                                            vm.$router.push({name: 'home'})
                                        }
                                    } else {
                                        localStorage.verified = false;
                                        if (to) {
                                            vm.$router.push({name: 'getVerified', query: { to: to }})
                                        } else {
                                            vm.$router.push({name: 'getVerified'})
                                        }
                                    }
                                } else {
                                    if (to) {
                                        vm.$router.push({name: 'addTel', query: { to: to }})
                                    } else {
                                        vm.$router.push({name: 'addTel'})
                                    }
                                }
                            }).catch(function (e) {
                                alert(e)
                            })
                    })
                    .catch(function (e) {
                        console.log(e);
                    })
            },
            onSignInError (error) {
                console.log('OH NOES', error)
            }
        },
        mounted() {
            window.fbAsyncInit = function() {
                FB.init({
                    appId      : '431281457563641',
                    cookie     : true,
                    xfbml      : true,
                    version    : 'v5.0'
                });
            };
            (function(d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s); js.id = id;
                js.src = "//connect.facebook.net/en_US/sdk.js";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
        }
    }
</script>

<style scoped>
.login {
    padding: 18% 2%;
}
</style>